import { useRef } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import IconButton from "@material-ui/core/IconButton";
import ShoppingCartOutlinedIcon from "@material-ui/icons/ShoppingCartOutlined";
import CartService from "../../services/cart/Cart";
import Disabled from "../../components/disabled";
import { CartButton, CartIcon, BadgeCarts } from "./style";

const CartButtonStatus = (props) => {
  const history = useHistory();

  const appDisabled = useRef();

  const { carts, settings } = props;

  const onChangeRoute = (route, e, data) => {
    if (e) {
      e.preventDefault();
    }

    history.push(route, data);
  };

  const showCart = () => {
    // if (settings?.restaurant_status && settings?.services) {
    if (settings?.restaurant_status) {
      onChangeRoute("/carts");
    } else {
      appDisabled.current.changeStatus();
    }
  };

  return (
    <>
      <Disabled refrence={appDisabled} />
      {CartService.getCartLength(carts) ? (
        <CartButton>
          <BadgeCarts className="badge badge-danger">
            {CartService.getCartLength(carts)}
          </BadgeCarts>
          <IconButton onClick={showCart}>
            <CartIcon>
              <ShoppingCartOutlinedIcon className="f-25" />
            </CartIcon>
          </IconButton>
        </CartButton>
      ) : (
        false
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    carts: state.carts.carts,
    settings: state.settings?.settings,
  };
};

export default connect(mapStateToProps, false)(CartButtonStatus);
